<template>
  <div>
    <div class="element-search autosuggest-search-activator">
      <input v-on:focus="openSearch" v-model="search" :placeholder="place" class="form-group" type="text">

      <div class="search-with-suggestions-w over-search-field" :class="showBox">
        <div class="search-with-suggestions-modal">
          <div class="element-search">
            <input class="search-suggest-input" v-model="search" :placeholder="place" type="text">
            <div class="close-search-suggestions"><i v-on:click="closeSearch" class="os-icon os-icon-x"></i></div>
          </div>
          <div class="search-suggestions-group" v-if="users">
            <div class="ssg-header">
              <div class="ssg-icon">
                <div class="os-icon os-icon-users"></div>
              </div>
              <div class="ssg-name">{{ t.customers }}</div>
              <div class="ssg-info">{{ users.total }}</div>
            </div>
            <div class="ssg-content">
              <div class="ssg-items ssg-items-list">
                <a class="ssg-item" href="javascript:void(0)" v-on:click="selectUser(user)" v-for="user in users">
                  <div class="item-media"
                       :style="'background-image: url('+api+'api/v1/users/get/profile_pic/'+user.id+')'"></div>
                  <div class="item-name">{{ user.name }}
                    <br/>
                    <span>{{ user.username }}</span>
                  </div>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'userAutoComplete',
        props: {
            place: {
                Type: String,
                default: 'Search user.'
            },
            group: {
                Type: String,
                default: 'Client'
            }
        },
        data() {
            return {
                t: this.$root.t,
                api: window.api,
                search: '',
                show: false,
                users: null,
                total: 0,
                selected: null
            }
        },
        watch: {
            search() {
                this.fetchUsers();
            }
        },
        computed: {
            showBox() {
                return (this.show) ? 'show' : 'hide';
            }
        },
        methods: {
            openSearch() {
                this.show = true;
                this.users = null;
                this.search = ''
            },
            closeSearch() {
                this.show = false;
                this.search = ''
            },
            selectUser(user) {
                this.selected = null;
                this.$emit('selected', user);
                this.selected = user;
                this.closeSearch();
            },
            fetchUsers() {
                this.$http.get(api + 'api/v1/search/user', {params: {q: this.search, g: this.group}}).then(response => {
                    // get body data
                    this.users = response.body.result;
                    this.total = response.body.result.length;
                }, response => {

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .search-with-suggestions-w.over-search-field.show {
    display: block
  }

  .search-with-suggestions-w.over-search-field.hide {
    display: none
  }

  .search-with-suggestions-w.over-search-field {
    top: 0px;
    left: 21px;
    width: 100%;
    max-height: 350px;
    overflow: auto;
  }

  .autosuggest-search-activator {
    position: relative;
  }

  .element-wrapper .element-search input {
    padding: 4px 45px;
  }
</style>



// WEBPACK FOOTER //
// src/components/autocomplete/userAutoComplete.vue